import React from 'react';
import { Typography } from 'antd';
import './Footer.css';
import logo from '../images/brandsenpaiwhite.png';
import { FacebookFilled, LinkedinFilled, WhatsAppOutlined } from '@ant-design/icons';
import { MailOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Footer = () => {
  return (
    <footer className="bs-footer" id="footer">
      <div className="bs-footer__inner">
        {/* Left: logo + brand */}
        <div className="bs-footer__left">
          <img src={logo} alt="BrandSenpai logo" className="bs-footer__avatar" />
         <div className="bs-brand-block">
  <Title level={3} className="bs-brand">BrandSenpai</Title>
  <div className="bs-brand-icons">
<a href="mailto:brandsenpaihq@gmail.com" target="_blank" rel="noreferrer">
<MailOutlined style={{ fontSize: '20px', color: '#ffffff', marginRight: '12px' }} />
</a>
<a href="https://wa.me/6596432836" target="_blank" rel="noreferrer">
<WhatsAppOutlined style={{ fontSize: '20px', color: '#25D366' }} />
</a>
</div>
</div>




          
        </div>
        

        {/* Right: copyright, aligned right and wrapped */}
        <div className="bs-footer__right">
          <p className="bs-copy">
            © {new Date().getFullYear()} BrandSenpai<br />
            Built with strategy, creativity, and care.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
